import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as FilterBackButton from "../../../common/styles/FilterBackButtonStyles";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Focus";

const typeStyle = css`
    font-family: ${theme.fonts.bold};
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    line-height: 2.2rem;
    text-transform: uppercase;
`;

export const Text = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    ${typeStyle};
`;

export const Button = styled.button<{ hasWhiteBackground?: boolean; isPrimary?: boolean; hasIconLeft?: boolean }>`
    display: flex;
    align-items: center;
    padding: ${theme.space[2]}px ${theme.space[4]}px;
    color: ${theme.colors.white};
    background-color: ${theme.colors.titanium};
    ${typeStyle};

    ${focusStyle};
    ${({ isPrimary }) =>
        isPrimary &&
        css`
            background-color: ${theme.colors.azure};
        `};

    ${({ hasWhiteBackground }) =>
        hasWhiteBackground &&
        css`
            color: ${theme.colors.azure};
            background-color: ${theme.colors.white};

            &:focus,
            &:hover {
                color: ${theme.colors.azureHover};
            }
        `};

    ${Text} {
        ${({ hasIconLeft }) =>
            hasIconLeft
                ? css`
                      margin-left: ${theme.space[1]}px;
                  `
                : css`
                      margin-right: ${theme.space[1]}px;
                  `};
    }

    /* Fix position icon */
    .l-arrow-icon {
        position: relative;
        top: -2px;
    }

    html[dir="rtl"] & {
        ${Text} {
            ${({ hasIconLeft }) =>
                hasIconLeft
                    ? css`
                          margin-left: 0;
                          margin-right: ${theme.space[1]}px;
                      `
                    : css`
                          margin-left: ${theme.space[1]}px;
                          margin-right: 0;
                      `};
        }
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 54px;

    ${Button},
    ${FilterBackButton.Button} {
        justify-content: center;
        width: 50%;
    }
`;
